import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { WarehouseSelector } from "../rawData/warehouse/warehouseSelector";
import { WarehouseKeepingView } from "./warehouseKeeping-view"
import { WarehouseKeepingEditorViewModel } from "./warehouseKeepingEditor/warehouseKeepingEditor-viewModel";

export class WarehouseKeepingViewModel extends WindowViewModel implements IPopup {
    public getTitle(): string {
        return 'انبار گردانی';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.lineItems = ObservableArray.create<lineItem>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh();
    }

    closePopup() { }
    GetDefaultView(): View<ViewModel> {
        return new WarehouseKeepingView();
    }
    public getTypeId(): string {
        return "VM-CEF35A17-28B4-407A-B545-1E020B889B6E"
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems; } private _lineItems: ObservableArray<lineItem>;

    async refresh() {
        await this.loader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/GetAllWarehouseKeepings', {
                FurtherQueryInfo: filteringInformation,
            });
            this.lineItems.update(...result.KeepingList.map((x, i) => {
                let r = new lineItem(this);
                r.index = i + 1;
                r.id = x.Id;
                r.warehouseId = x.WarehouseId;
                r.warehouseName = x.WarehouseName;
                r.startTime = moment.utc(x.StartTime);
                r.finishTime = x.FinishTime == null ? null : moment.utc(x.FinishTime);
                r.status = x.Status == 1 ? "شمارش نشده" : x.Status == 2 ? "شمارش شده" : x.Status == 5 ? "نهایی شده" : "";
                return r;
            }))
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async createWarehouseKeeping():Promise<void>{
        let warehouseKeeping = new WarehouseKeepingCreator(this);
        let result = await this.showPopup(warehouseKeeping);
        if(result == true){
            this.refresh();
        }
    }

}

export class lineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: WarehouseKeepingViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId; } private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set startTime(v: moment.Moment) { this._startTime = v; } public get startTime(): moment.Moment { return this._startTime; } private _startTime: moment.Moment;
    public set finishTime(v: moment.Moment) { this._finishTime = v; } public get finishTime(): moment.Moment { return this._finishTime; } private _finishTime: moment.Moment;
    public set status(v: string) { this._status = v; } public get status(): string { return this._status;} private _status: string;
    private _typedParent:WarehouseKeepingViewModel;

    async showDetail() {
        let popup = new WarehouseKeepingEditorViewModel(this);
        await popup.loadById(this.id);
        let result = await this.requestShowingPopup(popup);
        if(result == true){
            this._typedParent.refresh();
        }
    }
}

export class WarehouseKeepingCreator extends ViewModel implements IPopup {
    public getTypeId(): string { return 'warehouse-creator'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.warehouseSelector = new WarehouseSelector(this);
        this.warehouseSelector.onSelectionChanged = w => {
            this.warehouseId = w.id;
            this.warehouseName = w.title;
        };

    }
    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector; } private _warehouseSelector: WarehouseSelector;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId; } private _warehouseId: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set useDefaultValue(v: boolean) { this._useDefaultValue = v; } public get useDefaultValue(): boolean { return this._useDefaultValue;} private _useDefaultValue: boolean;
    

    closePopup(result: boolean = false) {

    }

    back(){
        this.closePopup(false);
    }

    async createWarehouseKeeping() {
        try {
            this.isLoading = true;
            if (this.warehouseSelector.selectedItem == null) {
                this.messageBoxConfirmWarning('انبار انتخاب نشده است.', 'عدم امکان اجرای عملیات')
                return;
            }
            let confirmationResult = await this.messageBoxWarningYesNo(`آیا انبار گردانی جدید برای انبار ${this.warehouseSelector.selectedItem.title} ایجاد شود؟`, 'ایجاد انبار گردانی');
            if (confirmationResult == 'yes') {
                let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/CreateNewWarehouseKeeping', {
                    WarehouseId: this.warehouseSelector.selectedItem.id
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess('انبار گردانی جدید ایجاد شد', 'عملیات موفق');
                    this.closePopup(true);
                } else {
                    this.messageBoxConfirmWarning('خطا در ثبت انبار گردانی', 'خطا در عملیات');
                }
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در ثبت انبار گردانی', 'خطا در عملیات');
        } finally {
            this.isLoading = false;
        }
    }
}
